import { FC } from 'react';
import { orderDetailsState } from '../../../../../../../pages/order/edit/states/orderDetails/orderDetails.state';
import { PinnedText } from '../../../../../pinnedText/pinnedText.component';
import { useMediaQuery } from '@mui/material';

export const AddressPinned: FC<IAddressPinned> = ({ isAddressPinned }) => {
  const isFullHd = useMediaQuery('(min-width:1920px)');
  const handleUnpinClick = () => {
    orderDetailsState.pub.updateIsAddressPinned(false, isFullHd);
  };

  return (
    <PinnedText
      name='specialAddress'
      isPinned={!!isAddressPinned}
      handleUnpinClick={handleUnpinClick}
    />
  );
};

interface IAddressPinned {
  isAddressPinned?: boolean;
}
